import { PpnPublicCtrl } from './ppn.public.controller';
import template from './ppn.public.html';

/**
 * Directive to render PPN when previewing it during house configuration
 * and to display in storybook
 */
export const ppnPublic: angular.IDirectiveFactory = () => ({
  bindToController: true,
  controller: PpnPublicCtrl,
  template,
  link() {},
  restrict: 'AE',
  scope: {
    houseId: '@',
    imageUrl: '@',
    svgUrl: '@',
  },
});
